import React,{useState, useEffect} from 'react'
import './Skills.scss';
import {motion} from 'framer-motion';
import {ApplicationWrap,MotionWrap} from "../../wrapper";
import {urlFor, integrate} from '../../integrate'
import ReactTooltip from 'react-tooltip';

const Skills = () => {
  const [skills, setSkills] = useState([ ]);
  const [experiences, setExperiences] = useState([ ]);
  const [tooltip, showTooltip] = useState(true);

  useEffect(() => {
      const skillsQuery = `*[_type == "skills"]`;
      const experienceQuery = `*[_type == "experiences"]`;

      integrate.fetch(skillsQuery)
      .then((data)=> {
        setSkills(data);
      })

      integrate.fetch(experienceQuery)
      .then((data)=> {
        setExperiences(data);
      })

  }, [])
  
  return (
    <>
    <h2 className='head-text'><span>Skills</span> & <span>Experiences</span></h2>
    <div className="app__skills-container">
      <motion.div className="app__skills-list">
         {skills?.map((item)=> (
           <motion.div
           whileInView={{opacity:[0,1]}}
           transition={{duration:0.5}}
           className= "app__skills-item app__flex"
           key={item._id}
           >
           <div className='app__flex' style={{backgrounColor: item.bgcolor}}>
            {item.icon && (
                <img src={urlFor(item.icon)} alt={item.name} />
           ) }
           </div>
             <p className="p-text">{item.name}</p>
           </motion.div>
         ))}
      </motion.div>
       {/* Experience Section */}
       <div className="app__skills-exp">
          {experiences.map((item) => (
            <motion.div
              className="app__skills-exp-item"
              key={item.year}
            >
              <div className="app__skills-exp-year">
                <p className="bold-text">{item.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                {item.works.map((work) => (
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__skills-exp-work"
                      data-tip
                      data-for={work.name}
                      key={work.name}
                      onMouseEnter={() => showTooltip(true)}
                      onMouseLeave={() => {
                        showTooltip(false);
                        setTimeout(() => showTooltip(true), 50);
                      }}
                    >
                      <h4 className="bold-text">{work.name}</h4>
                      <p className="p-text">{work.company}</p>
                    </motion.div>
                    {tooltip &&  <ReactTooltip
                      id={work.name}
                      effect="solid"
                      arrowColor="#fff"
                      className="skills-tooltip"
                      
                    >
                      {work.desc}
                    </ReactTooltip>}
                  </>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
    </div>
    </>
  )
}

export default ApplicationWrap(MotionWrap(Skills,'app__skills'), 'skills', 'app__whitebg');